import { DropdownState } from './Dropdown.types'
import { IconButtonProps, MenuProps } from '@mui/material'
import { MouseEvent } from 'react'

export function getDropdownMenuProps({
  buttonId,
  menuId,
  dropdownAnchorElement,
  isOpen,
  closeDropdown
}: DropdownState): MenuProps {
  return {
    id: buttonId,
    'aria-labelledby': menuId,
    anchorEl: dropdownAnchorElement,
    open: isOpen,
    onClose: closeDropdown
  }
}

export function getMobileDropdownButtonProps(dropdownState: DropdownState): IconButtonProps {
  return {
    ref: dropdownState.buttonRef,
    id: dropdownState.buttonId,
    tabIndex: dropdownState.disabled ? -1 : 0,
    'aria-controls': dropdownState.isOpen ? dropdownState.menuId : undefined,
    'aria-haspopup': 'true',
    'aria-expanded': dropdownState.isOpen ? 'true' : undefined,
    onClick: (e: MouseEvent<HTMLElement>) => dropdownState.toggleDropdown(e.currentTarget)
  }
}
